import { getAPIUrl } from '../API'

//make post api call to /Deeds/TitleDeed
export type DeedsQueryParams =
  | {
      cmaid: string
    }
  | {
      schemeNo: string
      sectionNo: string
    }

export const requestDeedsQuery = async (values: DeedsQueryParams) => {
  //make api call
  const response = await fetch(getAPIUrl() + `/Deeds/DeedQuery`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    body: JSON.stringify(values),
  })

  if (!response.ok) {
    const data = await response.json()
    return data.data
  }
}
